jQuery(document).ready(function ($) {

    $('.profile-image').click(function () {
        let profile_dropdown = $('.profile-dropdown');
        if (profile_dropdown.hasClass('show')) {
            profile_dropdown.removeClass('show');
        } else {
            profile_dropdown.addClass('show');
        }
    });

});